/** ******* ROOT REDUCER ACTUALIZADO *********/
import { localizeReducer } from 'react-localize-redux';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { adjustmentReducer } from './adjustmentReducer';
import attendanceReducer from './attendanceReducer';
import { countryStateReducer } from './countryStateReducer';
import { customPayrollReducer } from './customPayrollReducer';
import { dailyListReducer } from './dailyListReducer';
import { payrollPersonHistoryReducer } from './payrollPersonHistoryReducer';
import { payrollValidationReducer } from './payrollValidationReducer';
import { regionStateReducer } from './regionStateReducer';
import tempEdgeReducer from './tempEdgeReducer';
import { timeEntryReducer } from './timeEntryReducer';
import { employeePayrollReducer } from './employeePayrollReducer';

const createRootReducer = (routerReducer) =>
  combineReducers({
    router: routerReducer,
    tempEdge: tempEdgeReducer,
    dailyListReducer,
    adjustmentReducer,
    timeEntryReducer,
    payrollValidationReducer,
    payrollPersonHistory: payrollPersonHistoryReducer,
    customPayrollReducer,
    localize: localizeReducer,
    form: formReducer,
    attendance: attendanceReducer,
    countryState: countryStateReducer,
    regionState: regionStateReducer,
    employeePayroll: employeePayrollReducer
  });

export default createRootReducer;
/** *******************************************/
